import { RowLayout } from "chorda-bulma";
import { withItem, withList } from "../../utils";
import { COUNTRIES } from "../../data";
import { Option, Select } from "./common/select";
export default () => {
    return RowLayout([
        Select({
            options: [
                Option({ text: 'Alice' }),
                Option({ text: 'Bob' }),
                Option({ text: 'Charlie' }),
            ]
        }),
        Select({
            options: COUNTRIES.map(country => Option({ text: country.name }))
        }),
        Select({
            size: 8,
            value: 'AD',
            options: COUNTRIES.map(country => Option({ text: country.name, value: country.alpha2Code }))
        }),
        Select({
            optionAs: withItem({
                reactions: {
                    item: (v) => ({ text: v.name })
                }
            }),
            as: withList({
                injections: {
                    items: () => COUNTRIES
                },
            })
        }),
    ]);
};
